const userEventCompletionStatus = {
  Unknown: 'Unknown',
  Completed: 'Completed',
  Registered: 'Registered',
  Failed: 'Failed'
};

export default userEventCompletionStatus;


// WEBPACK FOOTER //
// ./src/constants/user-event-completion-status.js